module.exports = __webpack_public_path__ + "img/conveyor-icon.43627b1b.svg";